export default __webpack_public_path__ + "static/media/container.a44ac7da.png";